import React, { useState, useEffect, useCallback } from 'react'
import { FaBars, FaTimes, FaFacebook, FaWhatsapp, FaFilePdf } from 'react-icons/fa'
import { BiPhoneCall } from 'react-icons/bi'
import { MdOutlineSendToMobile } from 'react-icons/md'
import logo from './images/logo.png'
import './Navbar.css'
import { Link } from 'react-scroll'

const NAV_LINKS = [
  { label: 'Home',       to: 'Hero',    offset: -90 },
  { label: 'Best Offers',to: 'Plan',    offset: -30 },
  { label: 'About',      to: 'About',   offset: 0   },
  { label: 'Team',       to: 'OurTeam', offset: -90 },
  { label: 'Contact',    to: 'Contact', offset: -90 },
]

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled]  = useState(false)

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY >= 80)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  const closeMenu = () => setMenuOpen(false)
  const toggleMenu = () => setMenuOpen(v => !v)

  const openInNewTab = url => window.open(url, '_blank', 'noopener,noreferrer')

  const copyLink = () => {
    navigator.clipboard.writeText('https://www.getnet.online').then(() => {
      alert('Link copied to clipboard!')
    })
  }

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`} aria-label="Main navigation">
      <div className="navbar__inner">

        {/* Logo */}
        <div className="navbar__logo">
          <Link to="Hero" smooth duration={500} offset={-90} onClick={closeMenu} aria-label="Go to top">
            <img src={logo} alt="GetNet logo" />
          </Link>
        </div>

        {/* Desktop nav links */}
        <ul className="navbar__links" role="menubar">
          {NAV_LINKS.map(({ label, to, offset }) => (
            <li key={to} role="none">
              <Link
                activeClass="navbar__link--active"
                to={to}
                spy smooth
                duration={500}
                offset={offset}
                className="navbar__link"
                role="menuitem"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop action buttons */}
        <div className="navbar__actions">
          <a href="tel:+918652816746" className="btn-primary navbar__btn" aria-label="Call us">
            <BiPhoneCall size={16} /> Call Now
          </a>
          <button
            className="navbar__icon-btn"
            onClick={() => openInNewTab('https://drive.google.com/file/d/1FClmgTdU_udzD1JCdi1ECcN0kF8esmpW/view')}
            aria-label="Download plans PDF"
            title="Download Plans PDF"
          >
            <FaFilePdf size={18} />
          </button>
          <a
            href="https://wa.me/+918652816746"
            className="navbar__icon-btn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            title="WhatsApp"
          >
            <FaWhatsapp size={18} />
          </a>
          <a
            href="https://www.facebook.com/ge.tnet.9279"
            className="navbar__icon-btn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            <FaFacebook size={18} />
          </a>
          <button className="navbar__icon-btn" onClick={copyLink} aria-label="Share website" title="Share">
            <MdOutlineSendToMobile size={18} />
          </button>
        </div>

        {/* Mobile burger */}
        <button
          className="navbar__burger"
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={`navbar__drawer${menuOpen ? ' navbar__drawer--open' : ''}`} role="dialog" aria-label="Mobile navigation">
        <ul className="navbar__drawer-links">
          {NAV_LINKS.map(({ label, to, offset }) => (
            <li key={to}>
              <Link
                to={to}
                smooth
                duration={500}
                offset={offset}
                className="navbar__drawer-link"
                onClick={closeMenu}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="navbar__drawer-actions">
          <a href="tel:+918652816746" className="btn-primary navbar__drawer-btn" onClick={closeMenu}>
            <BiPhoneCall size={16} /> Call Now
          </a>
          <button
            className="btn-primary navbar__drawer-btn"
            onClick={() => { openInNewTab('https://drive.google.com/file/d/1FClmgTdU_udzD1JCdi1ECcN0kF8esmpW/view'); closeMenu(); }}
          >
            <FaFilePdf size={16} /> Download Plans
          </button>
          <div className="navbar__drawer-social">
            <a href="https://wa.me/+918652816746" className="navbar__icon-btn" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <FaWhatsapp size={22} />
            </a>
            <a href="https://www.facebook.com/ge.tnet.9279" className="navbar__icon-btn" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook size={22} />
            </a>
            <button className="navbar__icon-btn" onClick={() => { copyLink(); closeMenu(); }} aria-label="Share">
              <MdOutlineSendToMobile size={22} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile overlay */}
      {menuOpen && <div className="navbar__overlay" onClick={closeMenu} aria-hidden="true" />}
    </nav>
  )
}

export default Navbar
